<div class="container" style="
margin-left: 39px;
">
    <h2 class="text-header mng-qualifier-header">{{'Manage Role Qualifiers'|translate}}</h2>

    <select [(ngModel)]="userRoles"class="slt-dropdown" placeholder="sel">
    
		<option *ngFor="let i of manageUserRolesList" [value]="i">{{i}}</option>

    </select>
   
 <div class="row align-mng-qualifier">
  <span class="mng-qualifier">{{'Market Qualifiers'|translate}}<input class="btn-mng-qualifier" type="submit" name="add" (click)="openPopUp(content)" value="{{'add'|translate}}"> </span>
 </div>   
    
<div class="row align-mng-qualifier">

    
   <div class="col-sm-4">
          
    <table class="tablesorter-blue" cellspacing="0" cellpadding="2" width="98%">
        <thead>
            <tr class="tablesorter-headerRow">
                <th class="sorter-false tablesorter-header" colspan="3" data-column="0" tabindex="0" unselectable="on" style="user-select: none;">
                    <div class="tablesorter-header-inner"> {{'Positively Qualified'|translate}}</div>
                </th>
             
              
            </tr>
            <tr class="tablesorter-headerRow">
                <th class="sorter-false tablesorter-header">
                    <div class="tablesorter-header-inner"> {{'Qualifier'|translate}}</div>
                   
                </th>
                <th class="sorter-false tablesorter-header">
                    <div  class="tablesorter-header-inner"> {{'Expires'|translate}}</div>
                </th>
                <th class="sorter-false tablesorter-header">
                    
                </th>
            </tr>
        </thead>
        <tbody class="mng-qa-para-style">
            <ng-container  *ngIf="globalMarketTypeList &&  globalMarketTypeList.length > 0">
            <tr *ngFor="let market of globalMarketTypeList">
              <td >
                {{market.qualifier}}
              </td>
              <td >
               {{market.expires|date:'dd.MM.yyyy'}}
              </td>
              <td>
                  <input class="deleteButton" type="button" value="{{'Delete'|translate}}" (click)="openDeletePopUp(del,market.qualifier)">
              </td>
            </tr>
        </ng-container>
            <tr *ngIf="globalMarketTypeList.length == 0">
                <td colspan="3">
                 {{'No Qualified Roles'|translate}}
                </td>
              </tr>
        </tbody>
    </table>
   </div>
   <div class="col-sm-4 tab-mng-qualifier">
    <table class="tablesorter-blue" cellspacing="0" cellpadding="2" width="98%">
        <thead>
            <tr class="tablesorter-headerRow">
                <th class="sorter-false tablesorter-header" colspan="3" data-column="0" tabindex="0" unselectable="on" style="user-select: none;">
                    <div class="tablesorter-header-inner"> {{'Negatively Qualified'|translate}}</div>
                </th>
              
              
            </tr>
            <tr class="tablesorter-headerRow">
                <th class="sorter-false tablesorter-header">
                    <div class="tablesorter-header-inner"> {{'Qualifier'|translate}}</div>
                   
                </th>
              
                <th>
                    
                </th>
            </tr>
        </thead>
        <tbody class="mng-qa-para-style">
            <ng-container  *ngIf="globalMarketTypeNegativeList && globalMarketTypeNegativeList.length > 0">
            <tr *ngFor="let market of globalMarketTypeNegativeList">
                <td>
                  {{market.qualifier}}
                </td>
               
                <td>
                    <input class="deleteButton" type="button" value="{{'Delete'|translate}}" (click)="delepopup2(del2,market.qualifier)">
                </td>
              </tr>
            </ng-container>
              <tr *ngIf="globalMarketTypeNegativeList.length == 0">
                  <td colspan="3">
                     {{'No Qualified Roles'|translate}}
                  </td>
                </tr>
        </tbody>
    </table>
   </div>
</div>  
<div class="row align-mng-qualifier">
    <span class="mng-qualifier">{{'User Type Qualifiers'|translate}}<input class="btn-mng-qualifier" type="submit" name="add" value="{{'add'|translate}}" (click)="openSecondPopUp(content1)"> </span>
  </div>   
     
 <div class="row align-mng-qualifier">
 
     
    <div class="col-sm-4">
           
     <table class="tablesorter-blue" cellspacing="0" cellpadding="2" width="98%">
         <thead>
             <tr class="tablesorter-headerRow">
                 <th class="sorter-false tablesorter-header" colspan="3" data-column="0" tabindex="0" unselectable="on" style="user-select: none;">
                     <div class="tablesorter-header-inner"> {{'Positively Qualified'|translate}}</div>
                 </th>
             </tr>
             <tr class="tablesorter-headerRow">
                 <th class="sorter-false tablesorter-header">
                     <div class="tablesorter-header-inner"> {{'Qualifier'|translate}}</div>
                 </th>
                 <th class="sorter-false tablesorter-header">
                     <div  class="tablesorter-header-inner"> {{'Expires'|translate}}</div>
                 </th>
                 <th></th>
             </tr>
         </thead>
         <tbody class="mng-qa-para-style">
            <ng-container  *ngIf="globalUserTypeList && globalUserTypeList.length > 0">
             <tr *ngFor="let market of globalUserTypeList" >
                <td>
                 {{market.qualifier}}
                  </td>
                  <td >
                   {{market.expires|date:'dd.MM.yyyy'}}
                  </td>
                 <td>
                    <input class="deleteButton" type="button" value="{{'Delete'|translate}}" (click)="delepopup3(del1,market.qualifier)">
                     </td>
             </tr>
             </ng-container>
             <tr  *ngIf="globalUserTypeList.length==0">
                <td colspan="3">
                  {{'No Qualified Roles'|translate}}
                </td>
              </tr>
         </tbody>
     </table>
    </div>
    <div class="col-sm-4 tab-mng-qualifier">
     <table class="tablesorter-blue" cellspacing="0" cellpadding="2" width="98%">
         <thead>
             <tr class="tablesorter-headerRow">
                 <th class="sorter-false tablesorter-header" colspan="3" data-column="0" tabindex="0" unselectable="on" style="user-select: none;">
                     <div class="tablesorter-header-inner">{{'Negatively Qualified'|translate}}</div>
                 </th>
             </tr>
             <tr class="tablesorter-headerRow">
                 <th class="sorter-false tablesorter-header">
                     <div class="tablesorter-header-inner"> {{'Qualifier'|translate}}</div>
                 </th>
                
                 <th></th>
             </tr>
         </thead>
         <tbody class="mng-qa-para-style">
            <ng-container  *ngIf="globalUserTypeNegativeList && globalUserTypeNegativeList.length > 0">
                <tr *ngFor="let market of globalUserTypeNegativeList" >
                   <td>
                    {{market.qualifier}}
                     </td>
                   
               <td>
                <input class="deleteButton" type="button" value="{{'Delete'|translate}}" (click)="delepopup4(del3,market.qualifier)">
            </td>
             </tr>
             </ng-container>
             <tr *ngIf="globalUserTypeNegativeList.length==0">
                <td colspan="3">
                 {{'No Qualified Roles'|translate}}
                </td>
              </tr>
         </tbody>
     </table>
    </div>
 </div> 
</div>

	<!--popup window-->
	<div class="modal-dialog modal-dialog-scrollable">
		<ng-template #content let-modal>
		
			<div class="modal-content">
			  <div class="modal-header">
				<div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle"> {{'Add Qualifier'|translate}}</div>
                <i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')"></i>
             
            </div>
			  <div class="modal-body">
				<div class="row">
                 <div class="col-sm-2">
                    <p class="mng-model-label"> {{'Qualifier Type'|translate}}</p>
                 </div>
                 <div class="col-sm-4">
                    <select class="mng-qualifier-dropdwn" (click)="positive($event)" [(ngModel)]="qualifierType">
                        <option disabled selected hidden value="">{{'Please Select'|translate}}</option>
                        <option value="true" >{{'Positively Qualified'|translate}}</option>
                        <option value="false">{{'Negatively Qualified'|translate}}</option>
                    </select>
                    </div>
                </div>
                <div class="row mng-qualifier-modal-wid">
                    <div class="col-sm-2">
                       <p class="mng-model-label">{{'Qualifier'|translate}}</p>
                    </div>
                    <div class="col-sm-6">
                       <select class="mng-qualifier-dropdwn" [(ngModel)]="userTypeQualifier" >
                           <option disabled selected hidden value="">{{'Please Select'|translate}}</option>
                           <option *ngFor="let country of countryList" [value]="country.id2" >{{country.name}}</option>
                       </select>
                       </div>
                   </div>
                <div class="row mng-qualifier-modal-wid">
                    <div class="col-sm-2">
                        <p class="mng-model-label">{{'Expires'|translate}}</p>
                     </div>
                     <div class="col-sm-3">
                        <input [disabled]="disabled" type="text" #dp1="bsDatepicker" bsDatepicker class="mng-modal-btn"
                        name="jobDate" id="jobDate" (ngModelChange)="changeDate('jobDate','dsrForm')" [(ngModel)]="date"
                        [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY',customTodayClass: 'custom-today-class'}" >
                  </div>
                </div>
                
			  </div>
			  <div class="modal-footer">
				<button type="button" class="btn mng-model-btn-add shadow-none" (click)="add()">{{'add'|translate}}</button>	
			    <button type="button" class="btn mng-model-btn-add shadow-none" (click)="modal.dismiss('Cross click')">{{'Cancel'|translate}}</button>	
					
			</div>
			</div>
        
			  </ng-template>
	</div>


    	<!--popup window-->
	<div class="modal-dialog modal-dialog-scrollable">
		<ng-template #content1 let-modal>
		
			<div class="modal-content">
			  <div class="modal-header">
				<div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Add Qualifier'|translate}}</div>
                <i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')"></i>
			  </div>
			  <div class="modal-body">
				<div class="row">
                 <div class="col-sm-2">
                    <p class="mng-model-label">{{'Qualifier Type'|translate}}</p>
                 </div>
                 <div class="col-sm-4">
                    <select class="mng-qualifier-dropdwn" (click)="positive($event)" [(ngModel)]="qualifierType">
                        <option disabled selected hidden value="">{{'Please Select'|translate}}</option>
                        <option value="true">{{'Positively Qualified'|translate}}</option>
                        <option value="false">{{'Negatively Qualified'|translate}}</option>
                    </select>
                    </div>
                </div>
                <div class="row mng-qualifier-modal-wid">
                    <div class="col-sm-2">
                       <p class="mng-model-label">{{'Qualifier'|translate}}</p>
                    </div>
                    <div class="col-sm-6">
                        <select class="mng-qualifier-dropdwn" [(ngModel)]="userTypeQualifier">
                            <option disabled selected hidden value="">{{'Please Select'|translate}}</option>
                            <option value="INDEPENDENT">{{'Independent Operator'|translate}}</option>
                            <option value="FORD_INTERNAL">{{'Ford Internal Personal'|translate}}</option>
                            <option value="AUTHORIZED">{{'Authorized Reparier'|translate}}</option>
                        </select>
                       </div>
                   </div>
                <div class="row mng-qualifier-modal-wid">
                    <div class="col-sm-2">
                        <p class="mng-model-label">{{'Expires'|translate}}</p>
                     </div>
                     <div class="col-sm-3">
                        <input [disabled]="disabled" type="text" #dp1="bsDatepicker" bsDatepicker class="mng-modal-btn"
                        name="jobDate" id="jobDate" (ngModelChange)="changeDate('jobDate','dsrForm')" [(ngModel)]="date"
                        [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY',customTodayClass: 'custom-today-class'}" >
                  </div>
                </div>
                
			  </div>
			  <div class="modal-footer">
				<button type="button" class="btn mng-model-btn-add shadow-none" (click)="addUser()">{{'add'|translate}}</button>	
			    <button type="button" class="btn mng-model-btn-add shadow-none" (click)="modal.dismiss('Cross click')">{{'Cancel'|translate}}</button>	
	
			</div>
			</div>
        
			  </ng-template>
    </div>
    <!-- Delete popuup -->
    <div class="modal-dialog modal-dialog-scrollable">
  
        <ng-template #del1 let-modal>
            <div class="modal-content">
                <div class="modal-header">
                  <div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Delete Qualifier'|translate}}</div>
                  <i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')" ></i>
                </div>
                <div class="deleteContent">
                    <p>{{'Are you sure you want to delete this qualifier'|translate}}?</p>
                </div>
            <div class="modal-footer">

				<button type="button" class="btn mng-model-btn-add shadow-none" (click)="deleteData('1')">{{'Delete'|translate}}</button>	
			    <button type="button" class="btn mng-model-btn-add shadow-none" (click)="modal.dismiss('Cross click')">{{'Cancel'|translate}}</button>	
	
            </div>
        </div>
        </ng-template>
   
</div>
<div class="modal-dialog modal-dialog-scrollable">
  
    <ng-template #del2 let-modal>
        <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Delete Qualifier'|translate}}</div>
              <i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')" ></i>
            </div>
            <div class="deleteContent">
                <p>{{'Are you sure you want to delete this qualifier'|translate}}?</p>
            </div>
        <div class="modal-footer">

            <button type="button" class="btn mng-model-btn-add shadow-none" (click)="deleteData('2')">{{'Delete'|translate}}</button>	
            <button type="button" class="btn mng-model-btn-add shadow-none"  (click)="modal.dismiss('Cross click')">{{'Cancel'|translate}}</button>	

        </div>
    </div>
    </ng-template>

</div>
<div class="modal-dialog modal-dialog-scrollable">
  
    <ng-template #del3 let-modal>
        <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Delete Qualifier'|translate}}</div>
              <i class="fa fa-times mng-qualifier-close-btn"(click)="modal.dismiss('Cross click')" ></i>
            </div>
            <div class="deleteContent">
                <p>{{'Are you sure you want to delete this qualifier'|translate}}?</p>
            </div>
        <div class="modal-footer">

            <button type="button" class="btn mng-model-btn-add shadow-none" (click)="deleteData('3')">{{'Delete'|translate}}</button>	
            <button type="button" class="btn mng-model-btn-add shadow-none" (click)="modal.dismiss('Cross click')">{{'Cancel'|translate}}</button>	

        </div>
    </div>
    </ng-template>

</div>
<div class="modal-dialog modal-dialog-scrollable">
  
    <ng-template #del let-modal>
        <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Delete Qualifier'|translate}}</div>
              <i class="fa fa-times mng-qualifier-close-btn"(click)="modal.dismiss('Cross click')" ></i>
            </div>
            <div class="deleteContent">
                <p>{{'Are you sure you want to delete this qualifier'|translate}}?</p>
            </div>
        <div class="modal-footer">

            <button type="button" class="btn mng-model-btn-add shadow-none" (click)="deleteData('4')">{{'Delete'|translate}}</button>	
            <button type="button" class="btn mng-model-btn-add shadow-none" (click)="modal.dismiss('Cross click')" >{{'Cancel'|translate}}</button>	

        </div>
    </div>
    </ng-template>
</div>
